import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Txt } from '@vst/beam';

import { selectStreamOnPromo } from '@app/redux/streamOnPromo';

import { SpinnerLoader } from '../SpinnerLoader';
import { useTranslation } from '../../utils';

export const LoadingAnimatedButton = () => {
  const { isOrderSubmitting } = useSelector(selectStreamOnPromo);
  const { t: placeOrderTranslate } = useTranslation('PlaceOrder');

  return (
    <Button fluid disabled={isOrderSubmitting} data-cy="completeOrderButton">
      <Txt variant="bodyLargeBold" data-cy="completeOrderButtonLoading">
        <SpinnerLoader size="16px" lineWeight={5} />
        {placeOrderTranslate('Loading')}
      </Txt>
    </Button>
  );
};
